export enum TestResultStatusEnum {
  CREATED = "CREATED",
  PENDING = "PENDING",
  POSITIVE = "POSITIVE",
  NEGATIVE = "NEGATIVE",
  SUCCESSFUL = "SUCCESSFUL",
  FAILED = "FAILED",
  MISSED = "MISSED",
  NONE = "NONE",
}
